import { useEffect, useState } from 'react'

import {
  DESKTOP_APP_RELEASES_URL,
  parseLatestDesktopAppRelease
} from './pepDesktopAppVersion'

export function useLatestDesktopAppRelease(enabled = true) {
  const [latestRelease, setLatestRelease] = useState(null)
  const [isLoading, setIsLoading] = useState(Boolean(enabled))
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!enabled) {
      setIsLoading(false)
      return undefined
    }

    let cancelled = false

    setIsLoading(true)
    setError(null)

    fetch(`${DESKTOP_APP_RELEASES_URL}?nocache=${Date.now()}`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to fetch desktop app RELEASES file')
        }
        return response.text()
      })
      .then(content => {
        if (cancelled) {
          return
        }
        setLatestRelease(parseLatestDesktopAppRelease(content))
      })
      .catch(fetchError => {
        if (cancelled) {
          return
        }
        setError(fetchError instanceof Error ? fetchError.message : String(fetchError))
        setLatestRelease(null)
      })
      .finally(() => {
        if (!cancelled) {
          setIsLoading(false)
        }
      })

    return () => {
      cancelled = true
    }
  }, [enabled])

  return { latestRelease, isLoading, error }
}
